import { dayStart, toDay } from "../filters";

const DAY = 86_400_000;

/** Every UTC day in the window, the empty ones included, so gaps show as gaps. */
export function fillDays(daily, from, to) {
  const byDay = new Map((daily ?? []).map((d) => [toDay(d.day), d]));
  const out = [];
  const start = dayStart(toDay(from));
  for (let t = start; t < to; t += DAY) {
    const key = toDay(t);
    const d = byDay.get(key) ?? {};
    const runs = d.runs ?? 0;
    const succeeded = d.succeeded ?? 0;
    const failed = d.failed ?? 0;
    const stopped = d.stopped ?? 0;
    // Anything not finished, failed or stopped is still open — older rows have no `waiting` count.
    const waiting = d.waiting ?? Math.max(0, runs - succeeded - failed - stopped);
    const date = new Date(t);
    out.push({
      key,
      runs,
      succeeded,
      failed,
      stopped,
      waiting,
      users: d.users ?? 0,
      accounts: d.accounts ?? 0,
      successRate: succeeded + failed ? succeeded / (succeeded + failed) : null,
      label: date.toLocaleDateString(undefined, { day: "numeric", month: "short", timeZone: "UTC" }),
      long: date.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }),
    });
  }
  return out;
}

/** A Mastra daily series (`[{ name, points }]` or bare points) as day → value. */
export function seriesByDay(series) {
  const points = Array.isArray(series) ? (series[0]?.points ? series.flatMap((s) => s.points) : series) : series?.points ?? [];
  const out = new Map();
  for (const p of points ?? []) {
    if (!p?.timestamp) continue;
    const k = toDay(p.timestamp);
    out.set(k, (out.get(k) ?? 0) + Number(p.value || 0));
  }
  return out;
}

/** The run-status groups the conversation list filters by, and the chart segments that open them. */
export const RUN_PARTS = [
  { key: "succeeded", status: "finished", label: "Finished", color: "var(--aa-good)" },
  { key: "waiting", status: "open", label: "Still open", color: "var(--aa-neutral)" },
  { key: "stopped", status: "stopped", label: "Stopped by user", color: "var(--aa-warn)" },
  { key: "failed", status: "failed", label: "Failed", color: "var(--aa-bad)" },
];
